/** Narrative text lists arrive as {code: text} (template) or [{code, text}] (AI). */
export const textsByCode = (value) =>
  Array.isArray(value) ? Object.fromEntries(value.map((x) => [x.code, x.text])) : value ?? {}

/** The flat VH-223 targets a week is planned against. */
export const mealPrepTargets = (targets) => {
  const v = (key) => targets?.[key]?.value ?? null
  return targets ? { kcal: v('calories_kcal'), protein_g: v('protein_g') } : null
}
